<template>
    <div class="fill-height">
        <TabBasic show-breadcrumbs>
            <div class="d-flex align-center">
                <v-text-field
                        v-model="search"
                        class="datatable-search"
                        dense
                        hide-details
                        outlined
                        prepend-inner-icon="mdi-magnify"/>
            </div>
            <v-data-table
                    :headers="header"
                    :items="organizations"
                    :loading="loading"
                    :search="search"
                    :item-class="getActiveClass"
                    class="rounded-lg shadow my-6">
                <template v-slot:[`item.actions`]="{ item }">
                    <span class="data-table-actions-column">
                    <TableAction v-if="userID === item.OwnerID" :tooltip="$t('tooltips.moreDetails')"
                                 icon="mdi-information"
                                 @click="showDetails(item)"/>
                 <!--    <TableAction v-if="userID === item.OwnerID"
                                 :tooltip="$t('tooltips.edit')"
                                 icon="mdi-pencil"
                                 @click="openEditDialog(item)"/> -->
                    <TableAction v-if="!item.IsSubscriptionExpired"
                                 :tooltip="$t('select')"
                                 :icon-color="organizationID === item.OrganizationID ? 'success':'primary'"
                                 :readonly="organizationID === item.OrganizationID"
                                 icon="mdi-check-bold"
                                 @click="selectOrganization(item.OrganizationID)"/>
                    <TableAction :tooltip="userID === item.OwnerID ? $t('remove') : $t('leave')"
                                 :icon="userID === item.OwnerID ? 'mdi-delete' : 'mdi-location-exit'"
                                 @click="leaveOrganization(item.OrganizationID, userID === item.OwnerID)"/>
                    </span>
                </template>
                <template v-slot:[`item.Name`]="{ item }">
                  <div :class="{'pointer': !item.IsSubscriptionExpired}"  @click="selectOrganization(item.OrganizationID)">{{item.Name}}</div>
                </template>
                <template v-slot:[`item.IsSubscriptionExpired`]="{item}" >
                    <div :class="{'pointer': !item.IsSubscriptionExpired}"  @click="selectOrganization(item.OrganizationID)">{{ getStatus(item.IsSubscriptionExpired) }}</div>
                </template>
            </v-data-table>
        </TabBasic>
        <DeleteDialog ref="deleteDialog" :delete-title="deleteActionTitle" :title="deleteTitle"/>
        <SubscriptionDetails :subscription="subscription" :subscriptionID="subscriptionID"
                             @close="subscriptionID = null"/>
        <SubscriptionEditDialog
                :open="openEditOrganizationDialog"
                :organization="editOrganization"
                @close="closeEditDialog"/>
        <NewSubscriptionDialog :open="openDialogNewSubscription" @close="closeDialog"/>
    </div>
</template>

<script>
import TabBasic from "@/components/reusable/TabBasic/TabBasic.vue";
import DeleteDialog from "@/components/reusable/Dialog/DeleteDialog.vue";
import SubscriptionDetails from "@/components/Subscription/SubscriptionDetails.vue";
import NewSubscriptionDialog from "@/components/reusable/Dialog/NewSubsriptionDialog.vue";
import SubscriptionEditDialog from "@/components/Subscription/SubscriptionEditDialog.vue";

export default {
  name: "SubscriptionList",
  components: {
    SubscriptionEditDialog,
    NewSubscriptionDialog,
    SubscriptionDetails,
    DeleteDialog,
    TabBasic
  },
  data() {
    return {
      search: '',
      loading: false,
      items: [],
      deleteActionTitle: '',
      deleteTitle: '',
      subscription: {},
      subscriptionID: null,
      openDialogNewSubscription: false,
      openEditOrganizationDialog: false,
      editOrganization: {
        OrganizationID: null,
        Name: '',
        Timezone: '',
      },
    }
  },
  computed: {
    organizations() {
      return this.$store.getters.getOrganizations;
    },
    header() {
      return [
        {text: this.$t('authentication.subscriptionName'), value: 'Name'},
        {text: this.$t('status'), value: 'IsSubscriptionExpired'},
        {text: '', value: 'actions', class: 'data-table-actions-column', cellClass: 'data-table-actions-column', sortable: false, width: 200, align: 'center'},
      ];
    },
    userID() {
      return this.$store.getters.getUserId;
    },
    organizationID() {
      return this.$store.getters.getOrganizationId;
    }
  },
  methods: {
    getStatus(isExpired) {
      if (isExpired) {
        return this.$t('subscription.expired')
      }
      return this.$t('user.active');
    },
    initItems() {
      this.loading = true;
      const url = this.$store.getters.circles(this.organizationId);
      this.axios.get(url).then(({data}) => {
        this.items = data.Result;
      }).finally(() => {
        this.loading = false;
      });
    },
    leaveOrganization(organizationID, isAdmin) {
      this.deleteActionTitle = isAdmin ? this.$t('remove') : this.$t('leave');
      this.deleteTitle = isAdmin ? this.$t('account.areYouSureRemoveOrganization') : this.$t('account.areYouSureLeaveOrganization');
      this.$refs.deleteDialog.openDialog().then((result) => {
        if (result) {
          let url = this.$store.getters.organization(organizationID);
          this.axios.delete(url).then(() => {
            this.$store.dispatch('refreshOrganizations');
            if (this.organizationID === organizationID) {
              this.$store.dispatch('setOrganizationId', null);
            }
          });
        }
      });
    },
    selectOrganization(organizationID) {
      this.$store.dispatch('setOrganizationId', organizationID);
    },
    getActiveClass(item) {
      return item.OrganizationID === this.organizationID ? 'active' : '';
    },
    showDetails(item) {
      this.subscription = item;
      this.subscriptionID = item.OrganizationID;
    },
    openEditDialog(item) {
      const organization = this.organizations.find((org) => org.OrganizationID === item.OrganizationID);
      this.editOrganization = {
        OrganizationID: item.OrganizationID,
        Name: item.Name,
        Timezone: item.Timezone || (organization ? organization.Timezone : '') || '',
      };
      this.openEditOrganizationDialog = true;
    },
    closeEditDialog(refreshOrganizations = false) {
      this.openEditOrganizationDialog = false;
      this.editOrganization = {
        OrganizationID: null,
        Name: '',
        Timezone: '',
      };
      if (refreshOrganizations) {
        this.$store.dispatch('refreshOrganizations');
      }
    },
    closeDialog(refreshOrganization = false) {
      this.openDialogNewSubscription = false;
      if (refreshOrganization) {
        this.$store.dispatch('refreshOrganizations');
      }
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
.active {
  background: #6c6b6b;

    td {
      font-weight: bold;
    }
  }
}
</style>